// config
import * as http from 'utils/http';
import config from 'config';

const getFilteredCarriers = async (search) => {
  const data = await http.get(`${config.BASE_ROUTE}v1/carriers/?search=${search}`);
  return data;
};

export default getFilteredCarriers;
